var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0004 3.2C17.0004 2.8 16.6504 2.5 16.2504 2.5H5.15039L6.15039 3.5H16.0004V3.8L11.2004 8.6L11.9004 9.3L16.7004 4.5C16.9004 4.3 17.0004 4.05 17.0004 3.8V3.2Z",
    fill: "#3A61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35 1.50005L2.35 2.50005H1.85C1.45 2.45005 1.05 2.75005 1 3.15005V3.70005C1 3.95005 1.1 4.20005 1.3 4.40005L7 10.1V15.25L7.95 15.65V9.70005L2 3.75005V3.50005H3.35L10 10.15V16.6L11 17V11.15L16.05 16.2L16.75 15.5L2.05 0.800049L1.35 1.50005Z",
    fill: "#3A61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear-filter.e5b4e7d92b2fc1a8180a7679e43345db.svg";
export { ForwardRef as ReactComponent };